// @flow

export { EWalletUssdFields } from './ewallet-ussd-fields';
